import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Styles from "./styles.module.scss";
import Headline4 from "../../components/headings/Headline4";
import { Icon } from '@iconify/react';
import PublicationsModal from '../../modal/createResource/publicationsModal';
import AwardsModal from '../../modal/createResource/awardsModal';
import DeleteModal from '../../modal/createResource/deleteModal'
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { getDetails, submitDetails } from './services';
import NotificationAlert from "../../components/notification";
// import mixpanelData from '../../utils/mixpanel';
import classnames from "classnames";
import Award from '../../dashboardFormComponents/awardsForm'
import mixpanelData from '../../utils/mixpanel';

interface Props {

    AwardHandler: (event: any) => void
    getUserDetails: (event: any) => void
    defaultValues: {
        awards: { name: string, certifiedYear: number, action: string, status:boolean}[],
        publication: {  title: string, year: number, link: string, status: boolean}[]
    },
     loginId: string | null ,
     displayNotification: (event: string) => void
     userLoginId: string | null

}

const Awards: React.FC<Props> = ({
  AwardHandler,
  getUserDetails,
  displayNotification,
  loginId,
  defaultValues,
  userLoginId
}) => {


    const { v4: uuidv4 } = require('uuid');
    const [ initialAwardValues, setInitialinitialAwardValues] = useState <any> ()
    const [section, setSection] = useState<string>('')
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    
   
    const [awardIndex, setawardIndex] = useState<number>(-1)
    const [visible, setVisible] = useState(true)
    const [visibleAwards, setvisibleAwards] = useState(true);
    const [visibleDeleteModal, setVisibleDeleteModal] =useState(true);  
    const [newAwards, setNewAwards] = useState<boolean>(false)
    const [editAwards, setEditAwards] = useState<boolean>(false)

 
  useEffect(() => {
    if(defaultValues) {
        setInitialinitialAwardValues(defaultValues.awards)
    }
  }, [])
  

  const addAwards = (data:any) => {
      let certification = {
          certification :
          {
              certificationId: data.certificationId ? data.certificationId : uuidv4(),
              name : data.name,
              certifiedYear : data.certifiedYear,
              status : true,
          },
          section:'certification',
          loginId: loginId,
          action: data.action,
          userLoginId: userLoginId,
          submittedBy: 'RECRUITER',
     }
     submitDetails(certification).then((response: any) => {
     if( response && response.status === 1) {

      mixpanelData('TG - Awards & Certification Details Updated', {
        'source': "Recruiter updates certification details",
        'Success':  true,
        'distinct_id': localStorage.getItem('Email'),
        'Recruiter email': localStorage.getItem('Email'),
        'Certification title' : data.name,
        'certified Year': data.certifiedYear,
        'Name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
        'Phone Number': response && response.data[0].profile_metadata.phoneNumber,
        'Email': response.data && response.data[0].profile_metadata.email,
      })
      mixpanelData('New TG - Awards & Certification Details Updated', {
        'source': "Recruiter updates certification details",
        'Success':  true,
        'distinct_id': localStorage.getItem('Email'),
        'Recruiter email': localStorage.getItem('Email'),
        'Certification title' : data.name,
        'Certified Year': data.certifiedYear,
        'Canddiate name': response && (response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata.lastName),
        'Phone Number': response && response.data[0].profile_metadata.phoneNumber,
        'Candidate email': response.data && response.data[0].profile_metadata.email,
        'Candidate loginid': userLoginId
      })
       
          onClose();
          getDetails(loginId).then((resp: any) => {                 
          setInitialinitialAwardValues(resp.data[0].profile_metadata.certification)   
          getUserDetails(loginId)
          displayNotification('Details saved successfully');
          // setMessage('Details saved successfully')
          // setNotification(true)
          // setTimeout(() => {
          // setNotification(false)
          // }, 3000); 
      })
      }
    })
  };


   const awardVisiblity = () => {
        setawardIndex(-1)
        setNewAwards(true)
   }

  const deleteVisible = () => {
    setVisibleDeleteModal(!visibleDeleteModal)
    setawardIndex(-1)

  }
  const Delete = (section:string) => {
       
      let value = {}
      if(section === 'certification'){
       value = {
          "action": 'delete', 
          "section": 'certification',
          "loginId": loginId,
          "userLoginId": userLoginId,
          "submittedBy": 'RECRUITER',
          "certification": {
              "certificationId":  initialAwardValues[awardIndex].certificationId
        } 
      }
    }
     submitDetails(value).then((response: any) => {     
       if(response && response.status === 1){

      //   if(section === 'certification'){
      //     mixpanelData('MWP-certification Details Deleted', {
      //         'source': "freelancer deletes certification details",
      //         'Success':  true,
      //         'distinct_id': response && response.data[0].profile_metadata.email,
      //         'Email':response.data[0].profile_metadata.email
      //       })
      // }
            getDetails(loginId).then((resp: any) => {      
                deleteVisible();                                 
                setInitialinitialAwardValues(resp.data[0].profile_metadata.certification) 
                getUserDetails(loginId)  
                displayNotification('Details deleted successfully') 
                // setMessage('Details deleted successfully')
                // setNotification(true)
                // setTimeout(() => {
                // setNotification(false)
                // }, 3000); 
            })
          }
       })
    }
   
  const onClose = () => {
    setawardIndex(-1)
    setNotification(false)
    setNewAwards(false)
    setEditAwards(false)
   }

    return (
      <section>
        {notification && <NotificationAlert onClose={onClose } closable={true} > {message} </NotificationAlert> }
        {!visibleDeleteModal && ( <DeleteModal onClose={deleteVisible}  onSubmit={Delete} section={section} /> )}
          {initialAwardValues && initialAwardValues.map((item: any,key: any) => {
           return (
            <div>
               { key !== awardIndex ? <div className={Styles.workExpWrapper} key={key}> 
                <div className={classnames(Styles.workExpCard, Styles.eduExpCard)}>
                    <div className={Styles.workExpHead}>
                      <div>
                        <h6>{item.name}</h6>
                        <div className={Styles.expDate}>{item.certifiedYear}</div>
                      </ div>
                      <div className={Styles.actions}>
                        <Icon icon="lucide:edit-2" onClick={ () => {setEditAwards(true); setawardIndex(key)}}/>
                        <Icon icon="mdi:trash-can-outline" onClick={ () => {deleteVisible();  setawardIndex(key); setSection('certification') }}/>
                      </div>
                    </div>
                  </div>
                </div> : <Award ClickHandler={addAwards} defaultValues={awardIndex !== -1 ? initialAwardValues[awardIndex] : ''} onClose={onClose} />}
                
            </div>
           )
         })}
         <div>
          { newAwards ? <Award ClickHandler={addAwards} defaultValues={awardIndex !== -1 ? initialAwardValues[awardIndex] : ''} onClose={onClose} />
                : <button className={Styles.addWorkHistory}  onClick={awardVisiblity }><Icon icon="fluent:add-circle-28-regular" />Awards & Certifications</button> }
          </div>
      </section>
    );
}
export default Awards

